import { Report192Container } from "../../../containers/borrowSystem/Report/Report192Container";

export function Report192Page() {
    return (
        <Report192Container />
    )
}